import { convexClient } from "@convex-dev/better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { emailOTPClient, usernameClient } from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";

export const authClient = createAuthClient({
  plugins: [convexClient(), usernameClient(), passkeyClient(), emailOTPClient()],
  sessionOptions: {
    refetchOnWindowFocus: false, // stops get-session on every tab focus
    refetchInterval: 900,        // optional: refresh every 15 min (seconds)
    refetchWhenOffline: false,
  },
});
